import { render, staticRenderFns } from "./BaseNewsLine.vue?vue&type=template&id=e0c206fe&"
import script from "./BaseNewsLine.vue?vue&type=script&lang=js&"
export * from "./BaseNewsLine.vue?vue&type=script&lang=js&"
import style0 from "./BaseNewsLine.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports